/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.FieldLabels {
    "use strict";
    
    export class FieldLabelsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.fieldLabels;
            this.sectionTemplatePath = "app/plugins/fieldLabels/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_FIELDLABELS_TAB_MAIN);
            this.initializeSections();
        }
     
        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_FIELDLABELS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.FieldLabelsMain,
                    this.identityService,
                    this.modalService,
                    this.securityKeys.BUSINESSINFO_FIELDLABELS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ

                ));
            }
            this.activate();
          
        }

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;
            //let fieldLabelsmodel = <Meevo.Model.FieldLabelsSettings>model;
            
        }


    }
}